(() => {
  const openButtons = document.querySelectorAll('[data-tradepro-filters-open]');
  const closeButtons = document.querySelectorAll('[data-tradepro-filters-close]');
  const panels = document.querySelectorAll('[data-tradepro-mobile-filters-panel]');
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  if (!openButtons.length || !panels.length) return;

  const setExpanded = (expanded) => {
    openButtons.forEach((button) => {
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const openFilters = () => {
    document.body.classList.add('tradepro-mobile-filters-open');
    setExpanded(true);

    const firstPanel = panels[0];
    const firstFocusable = firstPanel?.querySelector('button, a, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])');

    if (firstFocusable) {
      window.setTimeout(() => firstFocusable.focus(), 40);
    }
  };

  const closeFilters = () => {
    document.body.classList.remove('tradepro-mobile-filters-open');
    setExpanded(false);
  };

  openButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      openFilters();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      closeFilters();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeFilters();
    }
  });

  desktopQuery.addEventListener('change', () => {
    closeFilters();
  });
})();
